<template>
  <DefaultLayout>
    <template #sidebar="{ collapsed }">
      <UNavigationMenu
        :collapsed="collapsed"
        :items="links"
        orientation="vertical"
        tooltip
        popover
      />
    </template>

    <template #default>
      <slot/>
    </template>

  </DefaultLayout>
</template>

<script setup>
import DefaultLayout from './default.vue'

const organization = useState('organization')
const isAdmin = useState('isAdmin')

const links = computed(() => {
  return [];
});

</script>
